interface Testimonial {
  name: string;
  role: string;
  content: string;
  rating: number;
}

const testimonials: Testimonial[] = [
  {
    name: '李明远',
    role: '科技公司产品总监',
    content: '精品一区是我每天必读的内容平台。在信息泛滥的时代，能有这样一个精心筛选的内容源真的很珍贵。每篇文章都值得花时间认真阅读，收获满满。',
    rating: 5,
  },
  {
    name: '张思琪',
    role: '自由撰稿人',
    content: '作为一个内容创作者，精品一区不仅是我获取灵感的源泉，更是我学习的标杆。平台对内容质量的坚持让我很受触动，这也是我一直愿意在这里投稿的原因。',
    rating: 5,
  },
  {
    name: '王晓峰',
    role: '大学副教授',
    content: '我经常向学生们推荐精品一区的文章。特别是人文社科和科技前沿板块，文章既有深度又通俗易懂，非常适合作为课外拓展阅读材料。',
    rating: 5,
  },
  {
    name: '陈雅婷',
    role: '企业管理者',
    content: '商业财经板块的分析文章给了我很多启发。不同于一般的财经新闻，精品一区的文章更注重深度分析和趋势洞察，对实际决策很有帮助。',
    rating: 5,
  },
  {
    name: '刘浩然',
    role: '设计师',
    content: '生活美学板块的文章让我重新发现了日常生活中的美。从家居设计到茶文化，每一篇文章都像是一件精心雕琢的作品，读起来赏心悦目。',
    rating: 5,
  },
  {
    name: '赵雪梅',
    role: '医生',
    content: '健康养生板块的内容非常专业且实用，不像网上很多养生文章那样夸大其词。每篇都基于科学研究，给的建议也很落地，我经常分享给患者朋友。',
    rating: 5,
  },
];

export default function Reputation() {
  return (
    <section className="py-14 md:py-20 px-4 md:px-6 bg-background-100">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-900 mb-3">
            读者口碑
          </h2>
          <p className="text-foreground-600 max-w-xl mx-auto leading-relaxed">
            来自各行业读者的真实评价，他们的认可是我们坚持品质的最大动力。
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6">
          {testimonials.map((item, idx) => (
            <div key={idx} className="bg-background-50 rounded-lg p-5 md:p-6">
              <div className="flex items-center gap-1 mb-4">
                {Array.from({ length: item.rating }).map((_, i) => (
                  <i key={i} className="ri-star-fill text-amber-400 text-sm"></i>
                ))}
              </div>
              <p className="text-sm text-foreground-600 leading-relaxed mb-5">
                "{item.content}"
              </p>
              <div className="flex items-center gap-3 pt-4 border-t border-background-200">
                <div className="w-10 h-10 rounded-full bg-accent-100 flex items-center justify-center text-accent-500 font-semibold text-sm">
                  {item.name.charAt(0)}
                </div>
                <div>
                  <div className="text-sm font-medium text-foreground-800">{item.name}</div>
                  <div className="text-xs text-foreground-500">{item.role}</div>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}